// extracted by mini-css-extract-plugin
module.exports = {"container":"Message_container__TTLjB","text":"Message_text__0GD3e","warningIcon":"Message_warningIcon__D0UKk"};